import { useEffect } from "react";

export const SITE_URL = "https://www.capitalstone.it";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

// React 19 hoists <title>, <meta> and <link> rendered here into <head>.
// The static fallback tags in public/index.html are marked data-rh="true"
// and are removed once the app renders, so each route carries only its own.
export const Seo = ({ title, description, path = "/", image, noindex = false, type = "website", lang = "it" }) => {
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;

  useEffect(() => {
    document.head.querySelectorAll("[data-rh]").forEach((el) => el.remove());
  }, []);

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Capital Stone S.r.l." />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      {img === DEFAULT_IMAGE && <meta property="og:image:width" content="1200" />}
      {img === DEFAULT_IMAGE && <meta property="og:image:height" content="630" />}
      <meta property="og:locale" content={lang === "en" ? "en_GB" : "it_IT"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </>
  );
};
